const apiBase = process.env.REACT_APP_API;

export const getAllUsers = async (params = {}) => {
  const {
    page = 1,
    limit = 30,
    search = "",
    sortColumn = "user_id",
    sortOrder = "asc",
  } = params;

  try {
    // Building query string
    const queryParams = new URLSearchParams({
      page,
      limit,
      search,
      sortColumn,
      sortOrder,
    }).toString();

    const token = localStorage.getItem("token");

    const response = await fetch(`${apiBase}/user?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => "Unknown error");
      throw new Error(
        `Failed to fetch users data (${response.status}): ${errorText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getUserById = async (userId) => {
  if (!userId) {
    throw new Error("User ID is required");
  }

  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${apiBase}/user/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => "Unknown error");
      throw new Error(
        `Failed to fetch user data (${response.status}): ${errorText}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching user with ID ${userId}:`, error);
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  if (!userId) {
    throw new Error("User ID is required");
  }

  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${apiBase}/user/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(userData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.error?.message || `Failed to update user (${response.status})`
      );
    }

    return data;
  } catch (error) {
    console.error(`Error updating user with ID ${userId}:`, error);
    throw error;
  }
};
